export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14020.ab521cad.jpg";